import axios from 'axios'
import { downloadFile } from 'src/v3/utilities/filesystem'

/**
 * Extract MIME type from File object
 * Normalizes 'image/jpg' to 'image/jpeg'
 */
export function getFileMimeType(file: File): string {
  let mimeType = file.type
  if (mimeType === 'image/jpg') {
    return 'image/jpeg'
  }
  return mimeType
}

export function getS3ImageFilePath(url: string): string {
  return url.includes('originals')
    ? `${import.meta.env.VITE_CLOUDFRONT_URL}/images/${url.replace('originals', 'resized')}`
    : `${import.meta.env.VITE_CLOUDFRONT_URL}/public/${url}`
}

export function getS3OriginalImageFilePath(url: string): string {
  return url.includes('originals')
    ? `${import.meta.env.VITE_CLOUDFRONT_URL}/images/${url}`
    : `${import.meta.env.VITE_CLOUDFRONT_URL}/public/${url}`
}

export async function downloadOriginalImage(
  url: string,
  fileName: string,
): Promise<void> {
  let response = await axios.get(url, { responseType: 'blob' })
  downloadFile(response.data, fileName)
}

/**
 * Upload File directly to S3 with dynamic content-type
 */
export function uploadFileToS3(
  file: File,
  presignedUrl: string,
): Promise<void> {
  let contentType = getFileMimeType(file)

  return axios
    .put(presignedUrl, file, {
      headers: {
        'Cache-Control': 'max-age=2592000',
        'content-type': contentType,
      },
    })
    .then(() => {})
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to upload file to S3:', error)
      return Promise.reject(error)
    })
}

/**
 * Complete upload flow: get presigned URL and upload file
 * Generic function that works with any API endpoint
 */
export function uploadImage<T extends { url: string }>(
  file: File,
  getPresignedUrlFn: () => Promise<T>,
): Promise<T> {
  return getPresignedUrlFn().then((presignedUrlResponse) =>
    uploadFileToS3(file, presignedUrlResponse.url)
      .then(() => presignedUrlResponse)
      .catch((error) => Promise.reject(error)),
  )
}
